import { useEffect } from 'react'
import { useAuthStore, type AuthUser } from '../stores/auth'
import { api } from '../lib/api'
import type { Permission } from '@b4l/shared'

interface MeResponse {
  user: AuthUser
  permissions: Permission[]
}

/**
 * Bootstrap auth state on app mount: try /me with current token (or via refresh
 * cookie) to restore session after page reload. Sets `initialized` once done.
 */
export function useBootstrapAuth(): void {
  const { initialized, setUser, clear } = useAuthStore()

  useEffect(() => {
    if (initialized) return
    let cancelled = false
    ;(async () => {
      try {
        const res = await api.get<MeResponse>('/auth/me')
        if (!cancelled) setUser(res.data.user, res.data.permissions)
      } catch {
        if (!cancelled) clear()
      }
    })()
    return () => {
      cancelled = true
    }
  }, [initialized, setUser, clear])
}
